module.exports = __webpack_public_path__ + "static/media/green_card_bg_ar.5e80d85e.png";